import { useEffect, useRef, useState } from "react";
import * as Ads from "../../Utility/Ads/Ads";
import styles from "./ReleasingLeaderBoard.custom.module.css";
import cx from "classnames";

// Collapse once the user scrolls past this point...
const HIDE_AT = 300;
// ...and only expand again when they return near the very top. This gap must be
// larger than the leaderboard's collapsed height, otherwise the layout shift from
// collapsing drops scrollY back into the "show" band and the ad flickers.
const SHOW_AT = 0;

export default function ReleasingLeaderboardV2() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  // Sticky offset = the live height of the fixed <header>. Hardcoding it (e.g.
  // 119px for desktop) leaves a white gap on mobile, where the header is
  // shorter than the desktop value, so the ad sticks below the header bottom.
  const [headerHeight, setHeaderHeight] = useState<number>();
  // Ref mirror of the state so the scroll handler can read the latched value
  // without re-subscribing the listener on every toggle.
  const collapsedRef = useRef(false);

  useEffect(() => {
    const header = document.querySelector("header");
    if (!header) return;

    const measure = () =>
      setHeaderHeight(header.getBoundingClientRect().height);

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(header);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let ticking = false;

    const evaluate = () => {
      ticking = false;
      const y = window.scrollY;

      if (!collapsedRef.current && y > HIDE_AT) {
        collapsedRef.current = true;
        setIsCollapsed(true);
      } else if (collapsedRef.current && y <= SHOW_AT) {
        collapsedRef.current = false;
        setIsCollapsed(false);
      }
    };

    const handleScroll = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(evaluate);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    evaluate();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={cx(styles.wrapper, isCollapsed && styles.hide)}
      style={headerHeight ? { top: `${headerHeight}px` } : undefined}
    >
      <div className={styles.innerWrapper}>
        <Ads.AdsLeaderboard />
      </div>
    </div>
  );
}
